
import React from 'react';
import '../App.css'
import Loader from './Loader';

import loading from '../Assets/loading2.svg'
 
function Loading() {
  return (
   <div className='main'>
     <div className='background-svg'></div>
    <div className='container'>
      <div className=''>
        <div className='' style={{height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
          <div className='' style={{height: '50vh',display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
           <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingTop: '35px'}}>
             <Loader img={loading}/>
             <p>CHARGEMENT</p>
           </div>

          </div>
          <div className='copyright'>
          Kabakoo Academies. All rights reserved. © 2023
          </div>
        </div>
      </div>
    </div>
   </div>
  );
}

export default Loading;